/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect } from 'react';
import { Platform, TouchableOpacity } from 'react-native';
import Box from '../Box';
import CCColors from '@/Utils/CCColors';
import DateTimePicker, { DateType } from 'react-native-ui-datepicker';
import CCText from '../CCText';
import { StyleSheet } from 'react-native';
import SlideModal from '../SlideModal';
import { FontSizes, vs } from '@/Utils/Dimensions';

const CCDatePicker = ({
  onChange,
  value,
  isMobileOrTab,
  minDate,
  minAge,
  maxDate,
  customize = false,
  customStyle = {},
}) => {
  // Get the user's local date and format it as 'YYYY-MM-DD' for the web picker
  // const today = new Date().toLocaleDateString('en-CA'); // 'YYYY-MM-DD' format for HTML input

  const [selectedDate, setSelectedDate] = useState<DateType>();
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const formatDateForInput = date => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';

    // Adjust for timezone offset
    const offsetDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000,
    );

    // Extract the day, month, and year
    const day = String(offsetDate.getUTCDate()).padStart(2, '0'); // Use getUTCDate()
    const month = String(offsetDate.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = offsetDate.getUTCFullYear();

    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  };
  const [rawValue, setRawValue] = useState(
    value ? formatDateForInput(value) : '',
  );

  useEffect(() => {
    if (!value) {
      setRawValue('');
      return;
    }
    const parsed = typeof value === 'string' ? parseDate(value) : value;
    if (parsed instanceof Date && !isNaN(parsed.getTime())) {
      setRawValue(formatDateForWebInput(parsed));
    }
  }, [value]);

  const parseDate = dateString => {
    if (!dateString) return null;

    const parts = dateString.split('-');
    if (parts.length !== 3) return null;

    // Check if the format is YYYY-MM-DD (first part is a 4-digit year)
    if (parts[0].length === 4) {
      const [year, month, day] = parts.map(Number);
      return new Date(year, month - 1, day); // Month is zero-indexed
    }
    // Format is DD-MM-YYYY
    else {
      const [day, month, year] = parts.map(Number);
      return new Date(year, month - 1, day); // Month is zero-indexed
    }
  };

  const parsedValue = typeof value === 'string' ? parseDate(value) : value;
  const formattedDate =
    parsedValue instanceof Date && !isNaN(parsedValue.getTime())
      ? formatDateForInput(parsedValue)
      : 'Select Date';
  // Today's date in 'YYYY-MM-DD' format
  const today = formatDateForInput(new Date());

  const getMaxAllowedDate = (): Date => {
    const d = new Date();
    if (minAge) {
      const d = new Date();
      d.setFullYear(d.getFullYear() - minAge);
      return d;
    }
    return d;
  };

  const formatDateForWebInput = (date: Date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return '';
    const offsetDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000,
    );
    return offsetDate.toISOString().split('T')[0];
  };

  const validateAge = (date: Date) => {
    if (!(date instanceof Date) || isNaN(date.getTime())) return false;
    const today = new Date();
    const age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
      return age - 1;
    }
    return age;
  };

  const maxAllowedDate =
    maxDate === null
      ? undefined
      : formatDateForWebInput(maxDate || getMaxAllowedDate());

  // if (Platform.OS === 'web') {
  return (
    // isMobileOrTab ? (
    //   <Box>
    //     <TouchableOpacity
    //       onPress={() => setShow(true)}
    //       style={{
    //         padding: 10,
    //         backgroundColor: 'transparent',
    //         borderRadius: 5,
    //         borderWidth: StyleSheet.hairlineWidth,
    //         borderColor: CCColors.TextBoxes.Borders,
    //       }}>
    //       <CCText style={{color: CCColors.TextColor}}>{formattedDate}</CCText>
    //     </TouchableOpacity>
    //     <SlideModal visible={show} onClose={() => setShow(false)}>
    //       <DateTimePicker
    //         mode="single"
    //         date={selectedDate}
    //         onChange={({date}) => {
    //           setSelectedDate(date);
    //           onChange(date);
    //           setShow(false);
    //         }}
    //         maxDate={maxAllowedDate}
    //         minDate={minDate}
    //       />
    //     </SlideModal>
    //   </Box>
    // ) : (
    <>
      <Box
        style={{
          borderRadius: 10,
          borderColor: CCColors.Grey.Border,
          borderWidth: customize ? 0 : 1,
        }}>
        <input
          type="date"
          value={rawValue} // Use raw string state
          onChange={e => {
            const inputValue = e.target.value;
            setRawValue(inputValue); // Update raw value

            const selectedDate = inputValue ? new Date(inputValue) : null;
            if (selectedDate && !isNaN(selectedDate.getTime())) {
              const age = validateAge(selectedDate);
              if (minAge && age < minAge) {
                setError(`You must be at least ${minAge} years old`);
                return;
              }
              setError('');
              onChange(selectedDate); // Update parent state
            }
          }}
          style={
            customize
              ? customStyle
              : {
                margin: 15,
                fontSize: FontSizes[16],
                border: 'none',
                color: rawValue ? 'inherit' : '#A8A7A6',
              }
          }
          placeholder="mm/dd/yyyy"
          max={maxAllowedDate}
          min={minDate ? formatDateForWebInput(minDate) : undefined}
        />
      </Box>
      {error ? <CCText color={CCColors?.Red}>{error}</CCText> : null}
    </>
  );
};

export default CCDatePicker;
